"use client"

import { useEffect, useState } from "react"
import dynamic from "next/dynamic"

const NextTopLoader = dynamic(() => import("nextjs-toploader"), { ssr: false })

/**
 * Idle-mounted route progress bar. The loader bundle (~5 KB gzipped) and
 * its history-listener setup don't run until the browser reports idle —
 * keeping it off the LCP critical path. The window between first paint
 * and idle is far shorter than typical user time-to-first-click, so the
 * bar still appears for any internal navigation.
 *
 * `requestIdleCallback` isn't supported in Safari < 17; the setTimeout
 * fallback covers that case.
 */
export function TopLoaderLazy() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void) => number
    }
    if (typeof w.requestIdleCallback === "function") {
      w.requestIdleCallback(() => setReady(true))
      return
    }
    const id = window.setTimeout(() => setReady(true), 1500)
    return () => window.clearTimeout(id)
  }, [])

  if (!ready) return null
  return <NextTopLoader color="#182D56" height={3} showSpinner={false} />
}
